import {Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output, ViewChild} from '@angular/core';
import {PaginationModel} from "./pagination.model";

@Component({
    selector: 'tfl-pagination',
    template: require('./pagination.template.html')
})
export class PaginationComponent implements OnInit, OnChanges {

    model: PaginationModel;

    @Input('page') page: number = 1;
    @Input('total') total: number;
    @Input('limit') limit: number = 20;
    @Input('id') id: string;

    @Input('onlyArrows') onlyArrows: boolean = false;
    @Input('limits') limits: number[] = [20, 50, 100, 200, 500];

    @Output('onPaginationChange') onPaginationChange: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('pagination') pagination;

    ngOnInit(): void {
        this.model = {
            page: this.page || 1,
            limit: this.limit || 20
        };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['page'] && this.model) {
            this.model.page = this.page || 1;
        }
        if (changes['limit'] && this.model) {
            this.model.limit = this.limit || 20;
        }
    }

    handleRowPerPageSelected(limit) {
        this.model.limit = Number(limit);
        this.model.page = 1; // Reset to first page when changing rows per page
        this.onPaginationChange.emit(this.model);
    }

    handlePageChange(page: any) {
        if (page > 0
            && page != this.pagination.getCurrent()
            && page <= this.pagination.getLastPage()) {
            this.model.page = page;
            this.onPaginationChange.emit(this.model);
        }
    }

    handleClickPrevious(pagination: any) {
        if (!pagination.isFirstPage()) {
            pagination.previous();
        }
    }

    handleClickNext(pagination: any) {
        if (!pagination.isLastPage()) {
            pagination.next();
        }
    }

    public getPaginationValues() {
        return {...this.model, page: this.page};
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/pagination/pagination.component.ts